import React from "react";
import {
  SideMenuButton,
  SideMenuButton1,
  ICEButton,
  Label1,
  Label2,
} from "./SideMenuButton.styled";
import ImgICEButton from "../../assets/svg/iceButton.svg";
import PropTypes from "prop-types";

const SideMenuButtonComponent = (props) => {
  const { someProp, setShowICE, activeIceButton, ICEStatus } =
    props;

  return (
    <>
      {someProp === "tab-mobile-menu" ? (
        <SideMenuButton1>
          <ICEButton
            style={activeIceButton && ICEStatus === "Closed" ? { opacity: "1" } : { opacity: "0.4" }}
            disabled={!activeIceButton && ICEStatus === "Open"}
            onClick={() => {
              if (activeIceButton && ICEStatus === "Closed") {
                setShowICE(true);
              }
            }}
            onKeyDown={() => {
              if (activeIceButton && ICEStatus === "Closed") {
                setShowICE(true);
              }
            }}
          >
            Quick Assist
          </ICEButton>
          <Label1>Help!</Label1>
          <Label2>Need emotional help?</Label2>
        </SideMenuButton1>
      ) : (
        <SideMenuButton>
          <div className="heading">Need emotional help?</div>
          <div
            style={activeIceButton && ICEStatus === "Closed" ? { opacity: "1" } : { opacity: "0.4" }}
            className="btn-img-container"
            onClick={() => {
              if (activeIceButton && ICEStatus === "Closed") {
                setShowICE(true);
              }
            }}
            onKeyDown={() => {
              if (activeIceButton && ICEStatus === "Closed") {
                setShowICE(true);
              }
            }}
          >
            <img src={ImgICEButton} className="img" alt="I.C.E Button" />
            <span className="button">Quick Assist</span>
          </div>
          <span className="clickText">Click the button</span>
          <span className="emergencyText">Quick Assist</span>
        </SideMenuButton>
      )}
    </>
  );
};

export default SideMenuButtonComponent;

SideMenuButtonComponent.propTypes = {
  someProp: PropTypes.string,
  setShowICE: PropTypes.func,
  activeIceButton: PropTypes.bool,
  ICEStatus: PropTypes.string,
};
